import { request } from './client';

export const apiGetAllUsers = ({ page = 1, limit = 20, search = '' } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (search) params.set('search', search);
  return request(`/users?${params.toString()}`);
};

export const apiGetUserById = (id) => request(`/users/${id}`);

export const apiUpdateUserStatus = (id, isActive) =>
  request(`/users/${id}/status`, { method: 'PUT', body: { isActive } });
